import { gql } from '@apollo/client';
import { DEVICE_FRAGMENT } from '@/entities/device/@x/study';
import PATIENT_FRAGMENT from '../fragments/patientFragment';

const DELETED_STUDIES_QUERY = gql`
  query deletedStudies($filter: ClinicStudyFilterInput, $limit: Int) {
    deletedStudies(filter: $filter, limit: $limit) {
      id
      friendlyId
      deviceType
      info {
        patient {
          ...PatientFragment
        }
        interprettingPhysician {
          id
        }
      }
      start
      stop
      studyType
      status
      reportDueDate
      timezone
      initialDurationOfStudy
      studyTimeOffset
      facility {
        id
        name
        contact {
          country
        }
        timezone
      }
      device {
        ...DeviceFragment
      }
      ecgDetail
    }
  }

  ${DEVICE_FRAGMENT}
  ${PATIENT_FRAGMENT}
`;

export default DELETED_STUDIES_QUERY;
